import { useId } from "react"

// Copilot Studio's logo. Its gradients take ids unique to each copy: with the
// file's fixed ids, every copy paints with the first one in the page, and none
// shows when that one is hidden (a closed tab or menu).
export const CopilotStudioColorSvg = (props: React.SVGProps<SVGSVGElement>) => {
  const id = useId()

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 55 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M39.4455 6.53904C38.7388 4.1238 36.5134 2.4574 33.9927 2.4574H32.3369C29.5947 2.4574 27.2427 4.41912 26.747 7.11912L23.9099 22.6019L24.6166 20.1867C25.3232 17.7609 27.5486 16.0945 30.0693 16.0945H39.7091L43.7486 17.666L47.6404 16.0945H46.5119C43.9912 16.0945 41.7658 14.4281 41.0591 12.0129L39.4455 6.53904Z"
        fill={`url(#${id}-0)`}
      />
      <path
        d="M15.1349 47.4399C15.8416 49.8656 18.0669 51.5426 20.5982 51.5426H24.1208C27.2005 51.5426 29.7212 49.0852 29.8056 46.0055L30.1853 31.0817L29.3837 33.8239C28.6771 36.2496 26.4517 37.9055 23.931 37.9055H14.2068L10.7369 36.0281L6.98218 37.9055H8.10015C10.6314 37.9055 12.8568 39.5824 13.5634 42.0082L15.1349 47.4399Z"
        fill={`url(#${id}-1)`}
      />
      <path
        d="M33.7502 2.4574H14.0697C8.4377 2.4574 5.0627 9.8824 2.81622 17.3179C0.14786 26.1246 -3.33261 37.9054 6.7502 37.9054H15.251C17.7928 37.9054 20.0182 36.2285 20.7143 33.7816C22.1908 28.6136 24.7854 19.5961 26.8209 12.7301C27.8545 9.23904 28.7193 6.24373 30.0377 4.37693C30.7865 3.33279 32.0205 2.4574 33.7502 2.4574Z"
        fill={`url(#${id}-2)`}
      />
      <path
        d="M33.7502 2.4574H14.0697C8.4377 2.4574 5.0627 9.8824 2.81622 17.3179C0.14786 26.1246 -3.33261 37.9054 6.7502 37.9054H15.251C17.7928 37.9054 20.0182 36.2285 20.7143 33.7816C22.1908 28.6136 24.7854 19.5961 26.8209 12.7301C27.8545 9.23904 28.7193 6.24373 30.0377 4.37693C30.7865 3.33279 32.0205 2.4574 33.7502 2.4574Z"
        fill={`url(#${id}-3)`}
      />
      <path
        d="M20.2502 51.5426H39.9413C45.5627 51.5426 48.9377 44.107 51.1948 36.6715C53.8631 27.8648 57.3436 16.084 47.2608 16.084H38.76C36.2182 16.084 33.9928 17.7609 33.2967 20.2078C31.8202 25.3758 29.2256 34.4039 27.1901 41.2699C26.1565 44.7609 25.2917 47.7563 23.9733 49.623C23.2139 50.6672 21.9799 51.5426 20.2502 51.5426Z"
        fill={`url(#${id}-4)`}
      />
      <path
        d="M20.2502 51.5426H39.9413C45.5627 51.5426 48.9377 44.107 51.1948 36.6715C53.8631 27.8648 57.3436 16.084 47.2608 16.084H38.76C36.2182 16.084 33.9928 17.7609 33.2967 20.2078C31.8202 25.3758 29.2256 34.4039 27.1901 41.2699C26.1565 44.7609 25.2917 47.7563 23.9733 49.623C23.2139 50.6672 21.9799 51.5426 20.2502 51.5426Z"
        fill={`url(#${id}-5)`}
      />
      <defs>
        <radialGradient
          id={`${id}-0`}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-13.4523 -16.4331 15.4523 -12.6495 44.192 22.7233)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.096" stopColor="#00AEFF" />
          <stop offset="0.773" stopColor="#2253CE" />
          <stop offset="1" stopColor="#0736C4" />
        </radialGradient>
        <radialGradient
          id={`${id}-1`}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(12.1265 15.4322 -14.9696 11.7631 11.1946 37.8196)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFB657" />
          <stop offset="0.634" stopColor="#FF5F3D" />
          <stop offset="0.923" stopColor="#C02B3C" />
        </radialGradient>
        <linearGradient
          id={`${id}-2`}
          x1="15.9754"
          y1="6.48187"
          x2="18.7841"
          y2="38.976"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.156" stopColor="#0D91E1" />
          <stop offset="0.487" stopColor="#52B471" />
          <stop offset="0.652" stopColor="#98BD42" />
          <stop offset="0.937" stopColor="#FFC800" />
        </linearGradient>
        <linearGradient
          id={`${id}-3`}
          x1="16.2553"
          y1="2.41352"
          x2="17.7887"
          y2="37.8577"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3DCBFF" />
          <stop offset="0.247" stopColor="#0588F7" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id={`${id}-4`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(48.2563 12.6193) rotate(109.274) scale(47.1142 56.4413)"
        >
          <stop offset="0.066" stopColor="#8C48FF" />
          <stop offset="0.5" stopColor="#F2598A" />
          <stop offset="0.896" stopColor="#FFB152" />
        </radialGradient>
        <linearGradient
          id={`${id}-5`}
          x1="37.1797"
          y1="13.8975"
          x2="37.1595"
          y2="23.5552"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.058" stopColor="#F8ADFA" />
          <stop offset="0.708" stopColor="#A86EDD" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
